import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	pageData: {
		id: "",
		code: "",
		name: "",
		startDate: "",
		shortStartDate: "",
		endDate: "",
		shortEndDate: "",
		duration: 0,
		durationString: "",
		modality: {
			id: "",
			Code: "",
			name: "",
		},
		trainingClasses: [],
	},
};

const CourseDetailsSlice = createSlice({
	name: "CourseDetails",
	initialState: initialState,
	reducers: {
		updatePageData(state, action) {
			// console.log("update CourseDetails");
			// console.log(action);

			state.pageData = action.payload;
		},
	},
});

export const CourseDetailsActions = CourseDetailsSlice.actions;

export default CourseDetailsSlice;
